// src/pages/Resources.jsx
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import QuickExit from '../components/QuickExit.jsx';

export default function Resources() {
  const [data, setData] = useState(null);
  const [county, setCounty] = useState('');
  const [counties, setCounties] = useState([]);

  useEffect(() => {
    fetch('/api/resources/counties').then((r) => r.json()).then((b) => setCounties(b.counties ?? []));
  }, []);

  useEffect(() => {
    fetch(`/api/resources${county ? `?county=${encodeURIComponent(county)}` : ''}`)
      .then((r) => r.json()).then(setData);
  }, [county]);

  return (
    <div className="min-h-screen bg-cream">
      <QuickExit />
      <header className="px-6 py-5 flex items-center justify-between">
        <Link to="/" className="font-display font-semibold text-sage-600">Sauti</Link>
      </header>

      <main className="max-w-lg mx-auto px-6 pb-16">
        <h1 className="text-xl font-semibold">Help directory</h1>

        {data?.caveat && (
          <div className="mt-3 rounded-lg bg-coral/10 border border-coral/30 px-3.5 py-2.5 text-xs text-coral-600 leading-relaxed">
            {data.caveat}
          </div>
        )}

        <select
          value={county} onChange={(e) => setCounty(e.target.value)}
          className="mt-4 w-full rounded-md border border-ink/20 px-3 py-2 text-sm bg-white"
        >
          <option value="">All areas</option>
          {counties.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>

        <div className="mt-5 space-y-3">
          {(data?.resources ?? []).map((r, i) => (
            <div key={i} className="rounded-lg border border-ink/10 bg-white p-4">
              <div className="flex items-start justify-between gap-3">
                <div>
                  <div className="font-medium text-sm">{r.name}</div>
                  {r.county && <div className="text-xs text-ink/50 mt-0.5">{r.county}</div>}
                  {r.description && <div className="text-xs text-ink/60 mt-1">{r.description}</div>}
                </div>
                {r.phone ? (
                  <a href={`tel:${r.phone}`} className="shrink-0 rounded-full bg-sage text-white text-xs font-medium px-3 py-1.5">
                    Call {r.phone}
                  </a>
                ) : (
                  <span className="shrink-0 text-xs text-ink/40 italic">Number pending</span>
                )}
              </div>
            </div>
          ))}
          {data && data.resources.length === 0 && (
            <p className="text-sm text-ink/50">No listings yet for this area — try "All areas" for national helplines.</p>
          )}
        </div>
      </main>
    </div>
  );
}
